import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Star, Quote } from 'lucide-react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Testimonials = () => {
  const [testimonials, setTestimonials] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTestimonials();
  }, []);

  const fetchTestimonials = async () => {
    try {
      const response = await axios.get(`${API}/testimonials`);
      setTestimonials(response.data);
    } catch (error) {
      console.error('Error fetching testimonials:', error);
      // Fallback data
      setTestimonials([
        {
          id: '1',
          name: 'Rajesh Sharma',
          location: 'Mumbai, India',
          quote: 'ShopCompareInsure helped my family secure the right coverage with premium financing. Their understanding of Indian family values made all the difference.',
          rating: 5
        },
        {
          id: '2',
          name: 'Priya Patel',
          location: 'Singapore',
          quote: 'The comparison tool saved me weeks of research. I found a policy from a top-rated carrier that perfectly fits my estate planning needs.',
          rating: 5
        },
        {
          id: '3',
          name: 'Ahmad Hassan',
          location: 'Dubai, UAE',
          quote: 'Professional, discreet, and incredibly knowledgeable about cross-border insurance. Highly recommend for HNWI families.',
          rating: 5
        }
      ]);
    } finally {
      setLoading(false);
    }
  };

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  useEffect(() => {
    if (testimonials.length > 1) {
      const interval = setInterval(nextTestimonial, 6000);
      return () => clearInterval(interval);
    }
  }, [testimonials.length]);

  if (loading || testimonials.length === 0) {
    return (
      <div className="bg-slate-900/50 backdrop-blur-md border border-slate-800 p-12 text-center">
        <div className="animate-pulse">
          <div className="h-6 bg-slate-700 rounded w-3/4 mx-auto mb-4"></div>
          <div className="h-4 bg-slate-700 rounded w-1/2 mx-auto"></div>
        </div>
      </div>
    );
  }

  const current = testimonials[currentIndex];

  return (
    <div className="relative" data-testid="testimonials-section">
      <div className="bg-slate-900/50 backdrop-blur-md border border-slate-800 p-8 md:p-12 relative overflow-hidden">
        {/* Decorative Quote */}
        <Quote className="absolute top-6 left-6 w-16 h-16 text-[#C5A059]/10" />
        
        <div className="relative z-10 max-w-3xl mx-auto text-center">
          {/* Stars */}
          <div className="flex justify-center mb-6 space-x-1">
            {[...Array(current.rating)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-[#C5A059] text-[#C5A059]" />
            ))}
          </div>

          {/* Quote */}
          <blockquote className="text-xl md:text-2xl text-slate-200 leading-relaxed font-serif italic mb-8">
            "{current.quote}"
          </blockquote>

          {/* Author */}
          <div>
            <p className="text-white font-semibold">{current.name}</p>
            <p className="text-slate-500 text-sm">{current.location}</p>
          </div>
        </div>

        {/* Navigation */}
        {testimonials.length > 1 && (
          <div className="flex justify-center items-center mt-8 space-x-4">
            <button
              onClick={prevTestimonial}
              className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center text-slate-400 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"
              data-testid="testimonial-prev"
            >
              <ChevronLeft className="w-5 h-5" />
            </button>
            
            {/* Dots */}
            <div className="flex space-x-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentIndex(index)}
                  className={`w-2 h-2 rounded-full transition-colors ${
                    index === currentIndex ? 'bg-[#C5A059]' : 'bg-slate-700'
                  }`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-10 h-10 rounded-full border border-slate-700 flex items-center justify-center text-slate-400 hover:border-[#C5A059] hover:text-[#C5A059] transition-colors"
              data-testid="testimonial-next"
            >
              <ChevronRight className="w-5 h-5" />
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Testimonials;
